import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  ObjectCondition,
  ObjectTrigger,
  SceneActionListItemDTO,
  SceneBlindState,
  SceneDimmerPowerState,
  SceneDimmerState,
  SceneFancoilSpeedState,
  SceneFancoilState,
  SceneLightState,
  SceneLockState,
  SceneObjectType,
  SceneShutterState,
  SceneSocketState,
  SceneStateComparer,
  SceneThermostatConditionState,
  SceneThermostatModalityState,
  SceneThermostatState,
  SceneTowelWarmerState,
  TriggersAndConditionsRoomObjectItemDTO,
} from '@/../client-generator/generated-clients/plants';

import RoomObjects from './RoomObjects/RoomObjects.vue';
import { cloneObject } from '@/core/utils/utils';
import DialogAddAction from '../DialogAddAction/DialogAddAction.vue';
import DialogAddTriggerAndCondition from '../DialogAddTriggerAndCondition/DialogAddTriggerAndCondition.vue';
import { SceneWizardStepEnum } from '../SceneWizardStep';

@Options({
  name: 'ScenePanelObjects',
  props: {
    roomsWithObjects: {
      required: true,
      type: Object as PropType<any[]>,
    },
    stepToAdd: {
      required: true,
      type: Number,
      default: SceneWizardStepEnum.STEP_ACTION,
    },
  },
  components: {
    RoomObjects,
    DialogAddAction,
    DialogAddTriggerAndCondition,
  },
  emits: ['add-action', 'add-trigger', 'add-condition'],
})
export default class ScenePanelObjects extends Vue {
  stepToAdd!: SceneWizardStepEnum;
  isVisibleDialogAction = false;
  isVisibleDialogTriggerOrCondition = false;
  tempToAdd:
    | SceneActionListItemDTO
    | TriggersAndConditionsRoomObjectItemDTO
    | null = null;
  triggerOrConditionType = SceneObjectType.None;
  triggerOrConditionName = '';

  openShowDialog(
    object: SceneActionListItemDTO | TriggersAndConditionsRoomObjectItemDTO
  ) {
    if (this.stepToAdd === SceneWizardStepEnum.STEP_ACTION) {
      this.tempToAdd = cloneObject(object);
      this.isVisibleDialogAction = true;
    } else if (this.stepToAdd === SceneWizardStepEnum.STEP_TRIGGER) {
      var tmp = object as TriggersAndConditionsRoomObjectItemDTO;
      this.triggerOrConditionType = tmp.sceneObjectType ?? SceneObjectType.None;
      this.triggerOrConditionName = tmp.name ?? '';

      this.tempToAdd = new ObjectTrigger({
        linkableObjectId: tmp.id,
        stateComparer: SceneStateComparer.None,
        lightState: SceneLightState.None,
        dimmerState: SceneDimmerState.None,
        dimmerPowerState: SceneDimmerPowerState.None,
        dimmerPercent: 0,
        shutterState: SceneShutterState.None,
        blindState: SceneBlindState.None,
        socketState: SceneSocketState.None,
        lockState: SceneLockState.None,
        thermostatState: SceneThermostatState.None,
        thermostatModalityState: SceneThermostatModalityState.None,
        thermostatConditionState: SceneThermostatConditionState.None,
        thermostatTemperature: 0,
        towelWarmerState: SceneTowelWarmerState.None,
        fancoilState: SceneFancoilState.None,
        fancoilSpeedState: SceneFancoilSpeedState.None,
        isSuspended: false,
      });
      this.isVisibleDialogTriggerOrCondition = true;
    } else if (this.stepToAdd === SceneWizardStepEnum.STEP_CONDITION) {
      var tmp = object as TriggersAndConditionsRoomObjectItemDTO;
      this.triggerOrConditionType = tmp.sceneObjectType ?? SceneObjectType.None;
      this.triggerOrConditionName = tmp.name ?? '';

      this.tempToAdd = new ObjectCondition({
        linkableObjectId: tmp.id,
        stateComparer: SceneStateComparer.None,
        lightState: SceneLightState.None,
        dimmerState: SceneDimmerState.None,
        dimmerPowerState: SceneDimmerPowerState.None,
        dimmerPercent: 0,
        shutterState: SceneShutterState.None,
        blindState: SceneBlindState.None,
        socketState: SceneSocketState.None,
        lockState: SceneLockState.None,
        thermostatState: SceneThermostatState.None,
        thermostatModalityState: SceneThermostatModalityState.None,
        thermostatConditionState: SceneThermostatConditionState.None,
        thermostatTemperature: 0,
        towelWarmerState: SceneTowelWarmerState.None,
        fancoilState: SceneFancoilState.None,
        fancoilSpeedState: SceneFancoilSpeedState.None,
        isSuspended: false,
      });
      this.isVisibleDialogTriggerOrCondition = true;
    }
  }

  handleDoAddObjectAction() {
    this.$emit('add-action', this.tempToAdd);
  }

  handleDoAddTriggerOrCondition() {
    if (this.stepToAdd == SceneWizardStepEnum.STEP_TRIGGER) {
      this.$emit(
        'add-trigger',
        this.tempToAdd as ObjectTrigger,
        this.triggerOrConditionName,
        this.triggerOrConditionType
      );
    } else if (this.stepToAdd == SceneWizardStepEnum.STEP_CONDITION) {
      this.$emit(
        'add-condition',
        this.tempToAdd as ObjectCondition,
        this.triggerOrConditionName,
        this.triggerOrConditionType
      );
    }
  }
}
